const enabledValues = new Set(['1', 'true', 'yes', 'on']);

// #756: Parts lookup is intentionally hidden while the driver journey focuses on
// shop handoff. Keep the implementation available for a future DIY-focused release.
export const PARTS_FLOW_ENABLED = enabledValues.has(
    String(process.env.REACT_APP_ENABLE_PARTS_FLOW || '').trim().toLowerCase()
);
